// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-icon__wrapper>a[data-v-1d21a7cc]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}", ""]);
// Exports
module.exports = exports;
